export function formatEvidenceTimestampLocal(raw?: string): string | null {
  const text = String(raw || '').trim();
  if (!text) return null;
  const normalized =
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?$/.test(text) ? `${text}Z` : text;
  const parsed = Date.parse(normalized);
  if (Number.isNaN(parsed)) return text;
  try {
    return new Date(parsed).toLocaleString(undefined, {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short',
    });
  } catch {
    return new Date(parsed).toLocaleString();
  }
}
